export default class CostCenter {
    constructor() {
        this.id = "";
        this.name = "";
        this.type = 1;
        this.icon = "fas fa-question";
        this.color = "#64B5F6";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.icon = data.icon;
        this.color = data.color;
    }
}
